import * as React from 'react';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';

import InputContainer from 'login-components/Common/Inputs/InputContainer/InputContainer';
import MaskedInput from './MaskedInput';

interface DataInputProps {
  contextProps: DataInputContextProps;
  inputProps: DirectInputProps;
}

/*
The point of the DataInput layer of abstraction is to create a separation between the underlying components
and Redux. The underlying components can be combined/composed freely without any knowledge of the overhead
logic, but this is the first place that we express knowledge (by swallowing the onBlur event).
*/

@autobind
class DataInput extends React.Component<DataInputProps, {}> {
  private localInputProps: DirectInputProps;

  constructor(props) {
    super(props);
    this.localInputProps = _.cloneDeep(props.inputProps);
    // TODO (UI-2778): remove this branching
    if (!this.props.contextProps.mask) {
      this.localInputProps.onBlur = this.handleBlur;
    }
  }

  handleBlur() {
    const { inputProps } = this.props;
    // Swallow the event to prevent Redux Form from
    // extracting the form value
    inputProps.onBlur();
  }

  render() {
    const { inputProps, contextProps } = this.props;
    // We're monkey-patching onBlur here because we want to be able to spread these
    // props directly onto the maskedInput.
    this.localInputProps.value = inputProps.value;

    return (
      <div className="DataInput">
        <InputContainer
          label={contextProps.label}
          name={inputProps.name}
          identifier={inputProps.name}
          prefix={contextProps.prefix || null}
          error={contextProps.error}
        >
          <MaskedInput
            mask={contextProps.mask}
            normalize={contextProps.normalize}
            format={contextProps.format}
            inputProps={this.localInputProps}
          />
        </InputContainer>
      </div>
    );
  }
}

export default DataInput;
